export default Object.freeze({
  FatherMotherOrManager: 1,
});
